import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/enterprise",
  component: RouteComponent,
  meta: { requiresAuth: true },
  children: [
    {
      path: "info",
      name: "enterprise.info",
      component: () =>
        import(
          /* webpackChunkName: "enterprise-info" */ "@/views/enterprises/EnterpriseView.vue"
        ),
      meta: {
        title: "enterprise-info",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "users",
      name: "enterprise.users",
      component: () =>
        import(
          /* webpackChunkName: "enterprise-users" */ "@/views/enterprises/EnterpriseUsersView.vue"
        ),
      meta: {
        title: "users-list-admin",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
        requiredRole: 2,
      },
    },
  ],
};
